import React, { useEffect, useState } from 'react';
import { useStoreState } from 'pullstate';
//Header Data
import headerLogo from '../assets/desall_logo.png';
import styles from './chooseUsername.module.scss';

//Footer Data
import footerImg from '../assets/footer_placeholder_transparent.png';
//Assets

//Components

import AppFooter from '../components/AppFooter/AppFooter';

import DslStore from '../store/DslStore';
import { getFooterMenu, getHeaderMenu } from '../store/Selectors';

import { useForm } from 'react-hook-form';
import { CreateFacebookUser, CreateTwitterUser, SignUpSocialForm } from '../global';
import { Link, useNavigate, Form } from 'react-router-dom';
import axiosHelper from '../helpers/axiosHelper';
import { useAuth } from '../context/AuthContext';
import { ROUTEPATHS } from './routePaths';
import { getSocialUser } from '../store/DesallSelectors';
import DesallStore from '../store/DesallStore';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppHeaderWLF from '../components/AppHeader/AppHeaderWLF';
import FormField from '../components/Forms/FormField';

const ChooseUsername: React.FC = () => {
  const { setLoggedUser: setUser } = useAuth();

  const footerMenu = useStoreState(DslStore, getFooterMenu);
  const headerMenu = useStoreState(DslStore, getHeaderMenu);
  const socialUser = useStoreState(DesallStore, getSocialUser);
  const [isEmailLocked, setIsEmailLocked] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [usernameError, setUsernameError] = useState(false);
  const [progress, setProgress] = useState(0);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    clearErrors,
    formState: { errors },
  } = useForm<SignUpSocialForm>({ mode: 'onBlur', reValidateMode: 'onBlur' });
  const redirect = useNavigate();

  useEffect(() => {
    if (socialUser?.user?.email) {
      setValue('email', socialUser.user.email);
      setIsEmailLocked(true);
    }
  }, [socialUser, setValue]);

  const onSubmit = async (data: SignUpSocialForm) => {
    console.log(data);
    console.log(socialUser && socialUser.user ? socialUser.user.email : 'No social user');
    if (data.agreement) {
      setProgress(1);
      console.log('agreement');
      if (socialUser?.social === 'F') {
        console.log('facebook');
        //facebook
        if (socialUser.user.email && socialUser.user.firstname && socialUser.user.lastname) {
          const cfu: CreateFacebookUser = {
            uid: socialUser.user.uid,
            email: socialUser.user.email,
            firstname: socialUser.user.firstname,
            lastname: socialUser.user.lastname,
            newsletter: data.receiveNewsletter,
            username: data.username,
          };
          await axiosHelper
            .createFacebookUser(cfu)
            .then((response) => {
              console.log(response);
              axiosHelper.setAuthToken(response.dslToken, true);

              setUser(response);
              // setCommunityUser(response);
              // axiosHelper.saveUserProfile(response);
              // setUserLogged(true);
              redirect(`/${ROUTEPATHS.COMMUNITY}/${response.nameForURL}/profile-editable`);
            })
            .catch((error) => {
              console.log(error);
              if (error.response.status === 409) {
                setUsernameError(true);
              }
              setProgress(0);
            });
        }
      } else if (socialUser?.social === 'T') {
        //twitter
        const ctu: CreateTwitterUser = {
          uid: socialUser.user.uid,
          email: data.email,
          username: data.username,
          newsletter: data.receiveNewsletter,
        };
        await axiosHelper
          .createTwitterUser(ctu)
          .then((response) => {
            console.log(response);
            axiosHelper.setAuthToken(response.dslToken, true);
            setUser(response);
            setTimeout(() => {
              redirect(`/${ROUTEPATHS.COMMUNITY}/${response.nameForURL}/profile-editable`);
            }, 1500);
          })
          .catch((error) => {
            console.log(error.response.status);
            if (error.response.status === 400) {
              setEmailError(true);
            }
            if (error.response.status === 409) {
              setUsernameError(true);
            }
            setProgress(0);
          });
      } else if (socialUser?.social === 'G') {
        console.log('google');
        //facebook
        if (socialUser.user.email && socialUser.user.firstname && socialUser.user.lastname) {
          const cfu: CreateFacebookUser = {
            uid: socialUser.user.uid,
            email: data.email,
            firstname: socialUser.user.firstname,
            lastname: socialUser.user.lastname,
            newsletter: data.receiveNewsletter,
            username: data.username,
          };
          await axiosHelper
            .createGoogleUser(cfu)
            .then((response) => {
              console.log(response);
              axiosHelper.setAuthToken(response.dslToken, true);

              setUser(response);
              redirect(`/${ROUTEPATHS.COMMUNITY}/${response.nameForURL}/profile-editable`);
            })
            .catch((error) => {
              console.log(error);
              if (error.response.status === 409) {
                setUsernameError(true);
              }
              setProgress(0);
            });
        }
      } else if (socialUser?.social === 'L') {
        //twitter
        const ctu: CreateTwitterUser = {
          uid: socialUser.user.uid,
          email: data.email,
          username: data.username,
          newsletter: data.receiveNewsletter,
        };
        await axiosHelper
          .createLinkedinUser(ctu)
          .then((response) => {
            console.log(response);
            axiosHelper.setAuthToken(response.dslToken, true);
            setUser(response);
            setTimeout(() => {
              redirect(`/${ROUTEPATHS.COMMUNITY}/${response.nameForURL}/profile-editable`);
            }, 1500);
          })
          .catch((error) => {
            console.log(error.response.status);
            if (error.response.status === 400) {
              setEmailError(true);
            }
            if (error.response.status === 409) {
              setUsernameError(true);
            }
            setProgress(0);
          });
      }
    }
  };

  const validateUsername = async (username: string) => {
    console.log('validating username: ' + username);
    if (!username) return true;

    try {
      const response = await axiosHelper.checkUsername(username);
      console.log(response);
      if (!response.available) {
        return 'A user with the same username already exists';
      }

      // return true;
    } catch (error) {
      console.error('Error validating username:', error);
      return 'Failed to validate username';
    }
  };

  const isValidEmailFormat = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateEmail = async (email: string) => {
    console.log('validating email: ' + email);
    if (!email) return true;

    if (!isValidEmailFormat(email)) {
      return 'Invalid email format';
    }

    try {
      const response = await axiosHelper.checkEmail(email);

      if (!response.available) {
        return 'A user with the same email already exists';
      }
      const fakeResponse = await axiosHelper.checkFake(email);

      if (fakeResponse.isFake) {
        return 'Blacklisted email provider';
      }

      return true;
    } catch (err) {
      console.log(err);
      return 'Failed to validate email';
    }
  };

  return (
    <>
      <AppHeaderWLF links={headerMenu} bgColor="#7997c5" logoImg={headerLogo} pageTitle="Choose username" hideSearch={true} />
      <main className="container-fluid py-5 bg-light-gray">
        <div className="row justify-content-center">
          <div className="col-12 col-md-4 col-lg-3">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row mb-5">
                <div className=" col-12 text-center">
                  <h1 className="bold-title">Choose username</h1>
                  <span className="sub-title color-dark my-5">Please select your Desall username</span>
                </div>
              </div>
              <div className="row">
                <FormField name="username" label="Username" required error={errors.username} fullWidth>
                  <input
                    type="username"
                    id="username"
                    placeholder="username"
                    {...register('username', { required: 'Username is required', minLength: 3, maxLength: 50, validate: validateUsername })}
                    onChange={(e) => {
                      clearErrors('username'); // clear the error immediately
                    }}
                  />
                </FormField>
              </div>
              <div className="row">
                <FormField name="email" label="Email" required error={errors.email} fullWidth>
                  <input
                    type="email"
                    id="email"
                    readOnly={isEmailLocked}
                    placeholder="email"
                    {...register('email', { required: 'Email is required', maxLength: 50, validate: validateEmail })}
                    onChange={(e) => {
                      clearErrors('email'); // clear the error immediately
                    }}
                  />
                </FormField>
              </div>
              <div className="row">
                <FormField name="agreement" label="User Agreement" required error={errors.agreement} fullWidth>
                  <div className="d-flex align-items-center">
                    <input type="checkbox" id="checkbox-1" {...register('agreement', { required: 'You must accept the User Agreement' })} className="" />
                    <label htmlFor="checkbox-1" className="d-block text-start ps-3 text">
                      I’m over 18 and agree to the <a href="#">User Agreement</a>
                    </label>
                  </div>
                </FormField>
              </div>
              <div className="row">
                <FormField name="privacy" label="Privacy Policy" required error={errors.privacy} fullWidth>
                  <div className="d-flex align-items-center">
                    <input type="checkbox" id="checkbox-2" {...register('privacy', { required: 'You must accept the Privacy Policy' })} className="" />
                    <label htmlFor="checkbox-2" className="d-block text-start ps-3 text">
                      I agree to the <a href="#">Privacy Policy</a>
                    </label>
                  </div>
                </FormField>
              </div>

              <div className="row">
                <FormField name="receiveNewsletter" label="Privacy Policy" required error={errors.receiveNewsletter} fullWidth>
                  <div className="d-flex align-items-center">
                    <input type="checkbox" id="checkbox-3" {...register('receiveNewsletter')} className="" />
                    <label htmlFor="checkbox-3" className="d-block text-start ps-3 text">
                      I want to receive the newsletter and agree to the <a href="#">Privacy policy Newsletter</a>
                    </label>
                  </div>
                </FormField>
              </div>
              <div className="row justify-content-center">
                <div className="col-12 my-5">
                  <button className="btn-dark-blue full rounded 3">Signup</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </main>
      <AppFooter links={footerMenu} bgColor="#304053" logoImg={headerLogo} bgImage={footerImg} />
    </>
  );
};

export default ChooseUsername;
